
import React, { Component } from 'react';
import { Checkbox } from 'antd';
import { CARD_TYPE } from '../../../../common/utils/static-data';

export class CardType extends Component {

    onChange = (value) => {
        const { onChange, } = this.props;
        onChange(value);
    }
    render() {
        const { value, disabled } = this.props;
        return (
            <div className="vat-fee">
                <Checkbox disabled={disabled} checked={value === CARD_TYPE.IDENTITY_CARD} onChange={() => this.onChange(CARD_TYPE.IDENTITY_CARD)}>CMND</Checkbox>
                <Checkbox disabled={disabled} checked={value === CARD_TYPE.CITIZEN_IDENTIFICATION} onChange={() => this.onChange(CARD_TYPE.CITIZEN_IDENTIFICATION)}>CCCD</Checkbox>
                <Checkbox disabled={disabled} checked={value === CARD_TYPE.PASSPORT} onChange={() => this.onChange(CARD_TYPE.PASSPORT)}>Hộ chiếu</Checkbox>
            </div>
        )
    }
}